import { render, staticRenderFns } from "./teacherVideo.vue?vue&type=template&id=9643088c&"
import script from "./teacherVideo.vue?vue&type=script&lang=js&"
export * from "./teacherVideo.vue?vue&type=script&lang=js&"
import style0 from "./teacherVideo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "teacherVideo.vue"
export default component.exports